/* Kit landing — interazioni: menu, buy flow (add-to-cart → drawer carrello → popup bump →
   checkout), drawer carrello, carosello prodotto, loop video "GIF" in viewport, facade
   video click-to-play, storie trascinabili, sticky bar, reveal soft, FAQ. Zero dipendenze. */
(function () {
  'use strict';

  var KIT_HANDLE = 'kit-operativo-ai-per-docenti-2026-27';

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --- Menu hamburger: drawer di navigazione --- */
  (function () {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-nav-drawer]');
    if (!toggle || !drawer) return;
    var closers = drawer.querySelectorAll('[data-nav-close]');
    var links = drawer.querySelectorAll('.nav-drawer__link');

    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 250);
    }
    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer(); else openDrawer();
    });
    closers.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    links.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();

  /* --- Carosello prodotto (hero): dots + frecce, swipe nativo scroll-snap --- */
  document.querySelectorAll('[data-pcar]').forEach(function (car) {
    var track = car.querySelector('[data-pcar-track]');
    var slides = Array.prototype.slice.call(car.querySelectorAll('[data-pcar-slide]'));
    var dotsWrap = car.querySelector('[data-pcar-dots]');
    if (!track || slides.length < 2) {
      car.querySelectorAll('.pcar__arrow').forEach(function (a) { a.hidden = true; });
      return;
    }
    var dots = slides.map(function (s, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'pcar__dot';
      d.setAttribute('aria-label', 'Slide ' + (i + 1) + ' di ' + slides.length);
      d.addEventListener('click', function () { goTo(i); });
      if (dotsWrap) dotsWrap.appendChild(d);
      return d;
    });
    function current() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    }
    function update() {
      var i = current();
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    var prev = car.querySelector('[data-pcar-prev]');
    var next = car.querySelector('[data-pcar-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    update();
  });

  /* --- Loop video "GIF" (showcase + hero): play in viewport, pause fuori.
     Pre-buffer intelligente: quando il video si AVVICINA al viewport (≈1,5 schermate)
     passa a preload=auto, così quando arrivi è già pronto e parte subito. --- */
  (function () {
    var vids = document.querySelectorAll('.media-slot--loop video, .media-slot video[autoplay], .pcar video[autoplay]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.preload = 'auto';
          near.unobserve(en.target);
        }
      });
    }, { rootMargin: '150% 0px' });
    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; near.observe(v); vio.observe(v); });
  })();

  /* --- Caricamento progressivo intelligente (rev. Pav 20/7 sera): dopo il primo paint
     si scarica TUTTO in background, in ordine: prima le slide del carosello hero, poi
     tutte le altre immagini lazy nell'ordine della pagina, poi i poster dei video
     click-to-play (preload=metadata). Così mentre scorri trovi le sezioni già cariche. --- */
  (function () {
    function sequentialLoad() {
      var carousel = Array.prototype.slice.call(document.querySelectorAll('.pcar img[loading="lazy"]'));
      var rest = Array.prototype.slice.call(document.querySelectorAll('main img[loading="lazy"]')).filter(function (im) {
        return carousel.indexOf(im) === -1;
      });
      var queue = carousel.concat(rest);
      function next() {
        var img = queue.shift();
        if (!img) {
          // Ultimo giro: i video facade pre-caricano i metadati (partenza immediata al tap)
          document.querySelectorAll('video.video-facade-target[preload="none"]').forEach(function (v) {
            v.preload = 'metadata';
          });
          return;
        }
        img.loading = 'eager';
        var done = false;
        function go() { if (!done) { done = true; next(); } }
        if (img.complete) { go(); return; }
        img.addEventListener('load', go, { once: true });
        img.addEventListener('error', go, { once: true });
        setTimeout(go, 4000); // rete lenta: non bloccare la coda su una sola immagine
      }
      next();
    }
    if (document.readyState === 'complete') {
      sequentialLoad();
    } else {
      window.addEventListener('load', function () { setTimeout(sequentialLoad, 300); });
    }
  })();

  /* --- Facade video click-to-play: poster pulito + play brand, al click parte il video --- */
  document.querySelectorAll('[data-video-facade]').forEach(function (facade) {
    facade.addEventListener('click', function () {
      var slot = facade.closest('.media-slot');
      var v = slot && slot.querySelector('video.video-facade-target');
      if (!v) return;
      facade.style.display = 'none';
      v.classList.add('is-active');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  });

  /* --- Selettore materia: chips che cambiano il pannello output --- */
  document.querySelectorAll('[data-materia-chips]').forEach(function (chips) {
    var panelsWrap = chips.closest('.materia__layout') || document;
    var panels = panelsWrap.querySelectorAll('[data-materia-panel]');
    chips.querySelectorAll('[data-materia-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var idx = chip.getAttribute('data-materia-index');
        chips.querySelectorAll('[data-materia-chip]').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-materia-index') === idx);
        });
      });
    });
  });

  /* --- Aggiunta al carrello IDEMPOTENTE (rev. 4 ago) -------------------------
     Sono tutti prodotti digitali: due copie dello stesso file non le vuole nessuno.
     Nei checkout abbandonati sono comparsi Kit ×2 (79,80 €) e Aggiornamenti a Vita ×2
     (59,88 €): totali che spaventano e fanno chiudere la pagina. Da qui in poi ogni
     aggiunta passa da qui: se la variante è già nel carrello NON si aggiunge nulla. --- */
  function addOnce(variantId) {
    var id = parseInt(variantId, 10);
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gia = cart.items.some(function (it) { return it.variant_id === id; });
        if (gia) return cart;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          return fetch('/cart.js').then(function (x) { return x.json(); });
        });
      });
  }

  /* --- Drawer carrello: apertura da destra, righe da /cart.js, upsell, rimozioni --- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var lastCart = null; // ultimo stato noto del carrello: serve al valore dell'InitiateCheckout
  function updateHeaderCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }
  // Rete di sicurezza: se per qualsiasi strada (link diretto, doppio invio, carrello
  // vecchio salvato dal browser) una riga arriva a più di una copia, la riportiamo a 1.
  // Prodotti digitali: due copie dello stesso file non servono a nessuno.
  var normalizzando = false;
  function normalizzaQuantita(cart) {
    if (normalizzando) return false;
    var doppia = cart.items.filter(function (it) { return it.quantity > 1; });
    if (!doppia.length) return false;
    normalizzando = true;
    var passo = function (i) {
      if (i >= doppia.length) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          normalizzando = false;
          renderCart(c);
          updateHeaderCount(c);
        });
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: doppia[i].key, quantity: 1 })
      }).then(function () { return passo(i + 1); }).catch(function () { normalizzando = false; });
    };
    passo(0);
    return true;
  }

  function renderCart(cart) {
    lastCart = cart;
    if (normalizzaQuantita(cart)) return;
    if (!cartDrawer) return;
    var itemsEl = cartDrawer.querySelector('[data-drawer-items]');
    var emptyEl = cartDrawer.querySelector('[data-drawer-empty]');
    var footEl = cartDrawer.querySelector('[data-drawer-foot]');
    var freebiesEl = cartDrawer.querySelector('[data-drawer-freebies]');
    var upsellEl = cartDrawer.querySelector('[data-drawer-upsell]');
    var countEl = cartDrawer.querySelector('[data-drawer-count]');
    var subEl = cartDrawer.querySelector('[data-drawer-subtotal]');
    var isEmpty = cart.item_count === 0;
    var hasKit = false;
    // Più upsell nel drawer (rev. 4/8): una card per prodotto, ognuna sparisce
    // se quel prodotto è già nel carrello. Il blocco sparisce se le nascondi tutte.
    var upsellCards = upsellEl ? [].slice.call(upsellEl.querySelectorAll('[data-upsell-card]')) : [];
    var inCart = {};

    itemsEl.innerHTML = '';
    cart.items.forEach(function (it) {
      if (it.handle === KIT_HANDLE) hasKit = true;
      inCart[it.handle] = true;
      var li = document.createElement('li');
      li.className = 'cart-drawer__item';
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
      // Selettore quantità (rev. Pav 29/7): se hai 2 copie devi poterne togliere una
      // senza svuotare la riga. Il "−" a quota 1 è spento: per rimuovere c'è la ×.
      var qty =
        '<div class="qty-step">' +
        '<button type="button" class="qty-step__btn" data-qty-key="' + it.key + '" data-qty="' + (it.quantity - 1) + '"' +
        (it.quantity <= 1 ? ' disabled' : '') + ' aria-label="Riduci la quantità">&minus;</button>' +
        '<span class="qty-step__val" aria-live="polite">' + it.quantity + '</span>' +
        // Il "+" resta visibile ma spento: sono file digitali, una copia basta. Il "−"
        // serve ancora a rientrare da eventuali doppioni storici.
        '<button type="button" class="qty-step__btn" data-qty-key="' + it.key + '" data-qty="' + (it.quantity + 1) + '" disabled title="È un prodotto digitale: una copia basta" aria-label="Aumenta la quantità">+</button>' +
        '</div>';
      li.innerHTML =
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="cart-drawer__item-body"><a href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' +
        qty +
        '</div>' +
        '<span class="cart-drawer__item-price">' + money(it.final_line_price) + '</span>' +
        '<button type="button" class="cart-drawer__item-remove" aria-label="Rimuovi dal carrello" data-line-key="' + it.key + '">&times;</button>';
      itemsEl.appendChild(li);
    });

    function changeLine(btn, key, quantity) {
      btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (c) { renderCart(c); updateHeaderCount(c); })
        .catch(function () { btn.disabled = false; });
    }

    itemsEl.querySelectorAll('[data-line-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn, btn.getAttribute('data-line-key'), 0);
      });
    });

    itemsEl.querySelectorAll('[data-qty-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = parseInt(btn.getAttribute('data-qty'), 10);
        if (isNaN(q) || q < 1) return;
        changeLine(btn, btn.getAttribute('data-qty-key'), q);
      });
    });

    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (footEl) footEl.hidden = isEmpty;
    if (freebiesEl) freebiesEl.hidden = !hasKit;
    if (upsellEl) {
      var visibili = 0;
      upsellCards.forEach(function (card) {
        var giaPreso = !!inCart[card.getAttribute('data-upsell-handle')];
        card.hidden = giaPreso;
        if (!giaPreso) visibili++;
      });
      upsellEl.hidden = isEmpty || visibili === 0;
    }
    if (countEl) { countEl.textContent = '· ' + cart.item_count; countEl.hidden = isEmpty; }
    if (subEl) subEl.textContent = money(cart.total_price);
  }
  function openCartDrawer() {
    if (!cartDrawer) { window.location.href = '/cart'; return; }
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        updateHeaderCount(cart);
        cartDrawer.hidden = false;
        requestAnimationFrame(function () { cartDrawer.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
      })
      .catch(function () { window.location.href = '/cart'; });
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { cartDrawer.hidden = true; }, 300);
  }
  if (cartDrawer) {
    cartDrawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeCartDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) closeCartDrawer();
    });
    var emptyCta = cartDrawer.querySelector('[data-drawer-empty-cta]');
    if (emptyCta) {
      emptyCta.addEventListener('click', function () {
        closeCartDrawer();
        var box = document.querySelector('.buy-box');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
    cartDrawer.querySelectorAll('[data-drawer-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = '…';
        addOnce(btn.getAttribute('data-drawer-add'))
          .then(function (c) { btn.disabled = false; btn.textContent = 'Aggiungi'; renderCart(c); updateHeaderCount(c); })
          .catch(function () { btn.disabled = false; btn.textContent = 'Aggiungi'; });
      });
    });
    // L'icona carrello nell'header apre il drawer invece di navigare
    document.querySelectorAll('.site-header__cart').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    });
  }

  /* --- Popup bump "Aggiornamenti a Vita" TRA carrello e checkout ---
     Mostrato UNA volta per sessione; qualunque chiusura porta comunque al pagamento. */
  var bumpModal = document.querySelector('[data-bump-modal]');
  function askBump(cb) {
    var done = null;
    try { done = sessionStorage.getItem('deBumpChoice'); } catch (err) {}
    if (!bumpModal || done) { cb(false); return; }
    var yes = bumpModal.querySelector('[data-bump-yes]');
    var closed = false;
    function close(choice) {
      if (closed) return;
      closed = true;
      try { sessionStorage.setItem('deBumpChoice', choice); } catch (err) {}
      bumpModal.classList.remove('is-open');
      setTimeout(function () { bumpModal.hidden = true; }, 250);
      cb(choice === 'yes');
    }
    bumpModal.hidden = false;
    requestAnimationFrame(function () { bumpModal.classList.add('is-open'); });
    if (yes) yes.addEventListener('click', function () { close('yes'); }, { once: true });
    bumpModal.querySelectorAll('[data-bump-no]').forEach(function (b) {
      b.addEventListener('click', function () { close('no'); }, { once: true });
    });
  }
  function bumpVariantId() {
    var yes = bumpModal && bumpModal.querySelector('[data-bump-yes]');
    return yes ? parseInt(yes.getAttribute('data-bump-variant'), 10) : null;
  }

  /* --- Buy flow (pagina Kit): CTA → add-to-cart → si apre il DRAWER (rev. Pav 20/7) --- */
  document.querySelectorAll('[data-kit-form]').forEach(function (form) {
    var fallback = false;
    form.addEventListener('submit', function (e) {
      if (fallback) return; // submit nativo dopo un errore fetch
      e.preventDefault();
      var btn = form.querySelector('[data-kit-buy]');
      var mainId = parseInt(form.querySelector('input[name="id"]').value, 10);
      var btnLabel = btn ? btn.textContent : '';

      if (window.__pixelTrack && btn) {
        window.__pixelTrack('AddToCart', {
          content_ids: [String(mainId)],
          content_name: btn.dataset.title,
          content_type: 'product_variant',
          value: parseFloat(btn.dataset.price),
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
      }

      if (btn) { btn.disabled = true; btn.textContent = 'Un attimo…'; }

      addOnce(mainId)
        .then(function () {
          if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
          openCartDrawer();
        })
        .catch(function () {
          // Fallback: submit nativo (porta alla pagina carrello)
          fallback = true;
          if (btn) { btn.disabled = false; btn.textContent = btnLabel; }
          form.submit();
        });
    });
  });

  /* --- "Vai al pagamento" (drawer + pagina carrello) → popup bump → checkout ---
     L'InitiateCheckout scatta QUI, dopo la scelta sul bump: si va davvero al pagamento.
     (Su hostitaliano farlo al click del bottone generava inizi-acquisto fantasma.) --- */
  document.querySelectorAll('[data-cart-checkout]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      askBump(function (withBump) {
        btn.disabled = true;
        btn.textContent = 'Un attimo…';
        if (window.__pixelTrack && !(window.DEPixel && window.DEPixel.fired('ic'))) {
          var val = parseFloat(btn.getAttribute('data-cart-value') || '') ||
            (lastCart ? lastCart.total_price / 100 : null);
          var p = { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' };
          if (val) { p.value = val; p.num_items = lastCart ? lastCart.item_count : 1; }
          window.__pixelTrack('InitiateCheckout', p);
        }
        var go = function () { window.location.href = '/checkout'; };
        var bumpId = withBump ? bumpVariantId() : null;
        if (bumpId) {
          addOnce(bumpId).then(go).catch(go);
        } else {
          go();
        }
      });
    });
  });

  /* --- Pagina carrello: checkbox add-on (Scrutini, PEI) aggiungono via AJAX e ricaricano --- */
  document.querySelectorAll('[data-cart-addon]').forEach(function (cb) {
    cb.addEventListener('change', function () {
      if (!cb.checked) return;
      cb.disabled = true;
      addOnce(cb.value)
        .then(function () { window.location.reload(); })
        .catch(function () { cb.disabled = false; cb.checked = false; });
    });
  });

  /* --- Storie recensioni: marquee JS trascinabile col dito, riparte da solo --- */
  document.querySelectorAll('[data-stories]').forEach(function (wrap) {
    var track = wrap.querySelector('.stories-track');
    if (!track) return;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    var half = 0, speed = 0, offset = 0, last = null, holdUntil = 0;
    var dragging = false, hover = false, moved = false;

    function measure() {
      half = track.scrollWidth / 2;
      var secs = parseFloat(wrap.style.getPropertyValue('--stories-speed')) || 45;
      speed = half > 0 ? half / secs : 0;
    }
    track.classList.add('is-js');
    measure();
    window.addEventListener('resize', measure);
    // Le immagini delle card sono lazy: quando arrivano la larghezza cambia → rimisura
    track.querySelectorAll('img').forEach(function (im) {
      if (!im.complete) im.addEventListener('load', measure, { once: true });
    });

    function frame(ts) {
      if (last === null) last = ts;
      if (!dragging && !hover && ts > holdUntil && half > 0) {
        offset += speed * ((ts - last) / 1000);
      }
      if (half > 0) {
        offset = ((offset % half) + half) % half;
        track.style.transform = 'translateX(' + -offset + 'px)';
      }
      last = ts;
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    var startX = 0, startOffset = 0;
    wrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true;
      moved = false;
      startX = e.clientX;
      startOffset = offset;
      wrap.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) moved = true;
      offset = startOffset - dx;
    });
    function release() {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('is-dragging');
      holdUntil = performance.now() + 600; // micro-ritardo, poi riparte da solo
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    if (canHover) {
      wrap.addEventListener('mouseenter', function () { hover = true; });
      wrap.addEventListener('mouseleave', function () { hover = false; });
    }
    // Un drag non deve "cliccare" i link delle card
    wrap.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  });

  /* --- Sticky bar mobile: appare superata la hero --- */
  var sticky = document.querySelector('[data-sticky-bar]');
  var hero = document.querySelector('[data-hero]');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      liftFabs();
    }, { rootMargin: '-80px 0px 0px 0px' }).observe(hero);
  }

  /* --- Chat + freccia "torna all'offerta": si alzano sopra la barra sticky quando c'è,
     così non finiscono mai una sopra l'altra. --- */
  function liftFabs() {
    var bar = document.querySelector('.cart-sticky') ||
      (sticky && sticky.classList.contains('is-visible') ? sticky : null);
    var h = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--fab-lift', h ? h + 8 + 'px' : '0px');
  }
  liftFabs();
  window.addEventListener('resize', liftFabs);

  /* --- Reveal soft on scroll --- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* --- FAQ: una sola aperta alla volta --- */
  document.querySelectorAll('.faq-list').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      if (e.target.open) {
        list.querySelectorAll('details[open]').forEach(function (d) {
          if (d !== e.target) d.open = false;
        });
      }
    }, true);
  });
})();
